<!-- <button
class="btn btn-primary btn-sm py-1 fw-light shadow me-2"
  (click)="share()">
  <i class="bi bi-facebook"></i> Share
</button> -->

<a (click)="share()" class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none">
  <i class="bi bi-facebook me-1"></i> {{ 'Share' | translate }}
</a>